// extracted by mini-css-extract-plugin
module.exports = {"toggle":"Toggle_toggle__1aHJy","inline":"Toggle_inline__2_eTG","block":"Toggle_block__oX2Xz","disabled":"Toggle_disabled__1Z6HQ","label":"Toggle_label__3-1yQ"};